/**
 * Un hook qui renvoie les dimensions de la fenêtre.
 * @returns {Object} - Contient la largeur et la hauteur de la fenêtre.
 */
import { useState, useEffect } from "react";
export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
}
